import React from 'react';
import ReactMarkdown from 'react-markdown';

export default function MessageBubble({ msg }) {
  return (
    <div className={`message-wrapper ${msg.direction}`}>
      <div className={`message-bubble ${msg.direction}`}>
        <ReactMarkdown>{msg.message}</ReactMarkdown>
      </div>
      <div className={`message-timestamp ${msg.direction}`}>
        {new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
      </div>
    </div>
  );
}